import { UnrealisedAssetFXGainOrLossType } from 'further-types/lp/unrealised-asset-fx-gain-or-loss';
import {
  UnrealisedCashFXGainOrLossActionType,
  UnrealisedCashFXGainOrLossType,
} from 'further-types/lp/unrealised-cash-fx-gain-or-loss';

export const UnrealisedCashFXGainOrLossActionTypeLabels = {
  [UnrealisedCashFXGainOrLossActionType.UnrealisedCashFXGainOrLossCreated]:
    'Unrealised Cash FX Gain or Loss ',
};

export const UnrealisedCashFXGainOrLossTypeLabels = {
  [UnrealisedCashFXGainOrLossType.UnrealisedCashFXGain]:
    'Unrealised Cash FX Gain',
  [UnrealisedCashFXGainOrLossType.UnrealisedCashFXLoss]:
    'Unrealised Cash FX Loss',
  [UnrealisedCashFXGainOrLossType.UnrealisedCashFXUnwindGain]:
    'Unrealised Cash FX Unwind Gain',
  [UnrealisedCashFXGainOrLossType.UnrealisedCashFXUnwindLoss]:
    'Unrealised Cash FX Unwind Loss',
};

export const UnrealisedAssetFXGainOrLossTypeLabels = {
  [UnrealisedAssetFXGainOrLossType.UnrealisedAssetFXGain]:
    'Unrealised Investment FX Gain (Unrealised Investment FX Gain)',
  [UnrealisedAssetFXGainOrLossType.UnrealisedAssetFXLoss]:
    'Unrealised Investment FX Loss (Unrealised Investment FX Loss)',
};
